import styled from 'styled-components';

export const ModalBody = styled.div`
	--offset: 60px;
	--header-height: 56px;
	--gap: 20px;
	--modal-position: fixed; // absolute / fixed
	margin-top: var(--gap);
	max-height: calc(
		(100vh - var(--header-height)) - ((var(--gap) * 7) + var(--offset))
	);
	padding-left: var(--gap);
	padding-right: var(--gap);
	padding-bottom: var(--gap);
	overflow: auto;
	-webkit-overflow-scrolling: touch;

	::-webkit-scrollbar {
		width: 8px;
	}

	::-webkit-scrollbar-track {
		background-color: #ebebeb;
		border-radius: 8px;
	}

	::-webkit-scrollbar-thumb {
		background-color: #000000;
		border-radius: 8px;

		:hover {
			background-color: #555555;
		}
	}
`;

export const ModalClose = styled.button`
	font-size: 0.7em;
	background-color: transparent;
	padding: 0;
	border: none;
	text-transform: uppercase;
	display: flex;
	align-items: center;
	margin-left: auto;
	margin-right: 0.7em;
    margin-top: 0.7em;
	line-height: 1em;
	gap: calc(var(--gap) * 0.5);

	span {
		font-size: 4.0em;
		line-height: 0.5em;
		font-weight: 500;
	}
`;

export const ModalInner = styled.div`
	position: fixed;
	width: 100%;
	max-width: 1200px;
	top: 100%;
	left: 50%;
	transform: translate(-50%, 100%);
	background-color: #282C34F0;
	color: #ffffff;
	padding: var(--gap);
	transition: transform var(--transition-speed) ease,
		top var(--transition-speed) ease;
`;

export const ModalContainer = styled.div`
	border: var(--gap) solid transparent;
	border-top: calc(var(--header-height) + 2px) solid transparent;
	width: 100%;
	height: 100%;
	position: relative;
	overflow: hidden;
	pointer-events: none;
`;

export const ModalBackground = styled.div`
	position: fixed;
	inset: 0;
	background-color: rgba(9, 14, 52, 0.6);
`;

export const ModalWrapper = styled.div`
	--transition-speed: 500ms;
	--z-index-modal: 30;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: var(--z-index-modal);
	transition: opacity calc(var(--transition-speed) * 0.25) ease;

	&.open {
		opacity: 1;
		pointer-events: auto;

		${ModalInner} {
			top: 52%;
			transform: translate(-50%, -50%);
			pointer-events: auto;
		}
	}

	&.closed {
		transition-delay: var(--transition-speed);
		opacity: 0;
		pointer-events: none;

		${ModalInner} {
			top: 100%;
			transform: translate(-50%, 100%);
		}
	}
`;
